import { initGlobal } from '@js/_common.ts'

initGlobal().then(() => {
  const interactiveSVG = document.querySelector('#frontpage-head__svg')

  if (interactiveSVG) {
    const allMarkers = Array.from(interactiveSVG.querySelectorAll<HTMLElement>('.frontpage-head__marker'))
    let currentMarker = 0

    setInterval(() => {
      if (currentMarker > allMarkers.length - 1) {
        currentMarker = 0
      }

      for (const marker of allMarkers) {
        marker.classList.remove('frontpage-head__marker--active')
      }

      allMarkers[currentMarker]?.classList.add('frontpage-head__marker--active')
      currentMarker++
    }, 3_000)
  }
})
